import { isServer } from '@app/utils';

const sessionStorageEffect =
  (key) =>
  ({ setSelf, onSet }) => {
    if (!isServer) {
      const savedValue = sessionStorage.getItem(key);

      if (savedValue != null) {
        setSelf(JSON.parse(savedValue));
      }

      onSet((newValue) => {
        sessionStorage.setItem(key, JSON.stringify(newValue));
      });
    }
  };

export default sessionStorageEffect;
